module.exports = __webpack_public_path__ + "img/tvhelper_pic_03.6f2987d5.png";